import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material'
import Cancel from './../../../../assets/icons/close.png'

import doc from './../../../../assets/images/LogoTransparent.png'

import { Girl } from '@mui/icons-material';

import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function RestaurantDetailsDialog(props) {
    const restaurant =
        props.restaurantName && typeof props.restaurantName === 'object'
            ? props.restaurantName
            : {};

    const getField = (field) => restaurant[field] ?? '';

    const displayName =
        getField('companyLegalName') ||
        [getField('firstName'), getField('surName')].filter(Boolean).join(' ') ||
        'Restaurant';

    const businessType =
        restaurant.businessTypeDescription ?? restaurant.businessTypeId ?? '';

    const handleClose = () => {
        props.onClose(false)
    }
    const onClickSave = () => {


    }
    const apiAddress = process.env.REACT_APP_SECRET;

    const approvedData = async () => {
        if (!restaurant.id) return;
        var ids = [];
        ids.push(restaurant.id);
        axios({
            method: 'put',
            url: apiAddress + '/api/NewRestaturantRequest/updateRestaurantRequests/1',
            data: ids
        })
            .then(function (response) {
                console.log(response);
                toast.success("Successfully Saved", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                // loadData();
                props.onClose(false)
            })
            .catch(function (error) {
                console.log(error);
                toast.error("Error" + error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }

    return (
        <div>
            <ToastContainer />
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth='lg'
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>{displayName} details</DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <div>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Restaurant Name
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Restaurant Name"
                                        value={getField('companyLegalName')}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Address
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Address"
                                        value={getField('address')}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Company Registration Number
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Company Registration Number"
                                        value={getField('companyRegistrationNumber')}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Business Type
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Business Type"
                                        value={businessType}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Applied By
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Name"
                                        value={[getField('firstName'), getField('surName')].filter(Boolean).join(' ')}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Contact Number
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Contact Number"
                                        value={getField('phoneNumber')}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Email
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Email"
                                        value={getField('email')}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Website Address
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>

                                    <TextField
                                        label="Website Address"
                                        value={getField('webSiteAddress')}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ sx: { color: '#371B17' } }}
                                    />
                                </Grid>
                                <Grid item xs={1} sx={{ paddingTop: '1.5rem', alignItems: "center" }}>

                                    {getField('webSiteAddress') ? (
                                        <a href={getField('webSiteAddress')} target="_blank" rel="noreferrer">Visit</a>
                                    ) : null}
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography sx={{ paddingTop: '1.5rem', alignItems: "center" }}>
                                        Documents
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    {getField('uploadedDocImagePath') ? (
                                        <a href={getField('uploadedDocImagePath')} target="_blank" rel="noreferrer">document</a>
                                    ) : (
                                        <Typography color="text.secondary">No document uploaded</Typography>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={12}>
                                    <div className='d-flex justify-content-end' style={{ gap: "10px" }}>
                                        {
                                            getField('approvalStatusDescription') === "Pending" ? (
                                                <button className='btn btn-success' onClick={() => { approvedData() }}>Approved</button>
                                            ) : ""
                                        }

                                        <button className='btn btn-danger' onClick={() => { handleClose() }}>Cancel</button>
                                    </div>
                                </Grid>


                            </Grid>


                        </div>
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        </div>
    );
}

export default RestaurantDetailsDialog;